var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tagBattery inline-block rounded-sm text-white text-xs text-center leading-none px-2 py-1"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }